var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ag-charts-vue',{staticStyle:{"height":"350px","width":"500px"},attrs:{"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }